import { render, staticRenderFns } from "./MessageProduct.vue?vue&type=template&id=7da7d9d5&scoped=true"
import script from "./MessageProduct.vue?vue&type=script&lang=js"
export * from "./MessageProduct.vue?vue&type=script&lang=js"
import style0 from "./MessageProduct.vue?vue&type=style&index=0&id=7da7d9d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da7d9d5",
  null
  
)

export default component.exports